import ToggleBarItem from './Item.js';
import ToggleBarSection from './Section.js';
import GroupUncontrollable from './GroupUncontrollable.js';

var ToggleBar = {
  Group: GroupUncontrollable,
  Item: ToggleBarItem,
  Section: ToggleBarSection
};

export { ToggleBar as default };
//# sourceMappingURL=index.js.map
